
import AppCrmEdit from "@/components/crm/CrmEdit.vue";
import Vue from "vue";
import { CrmService } from "@/services/crm-service";
import { CrmEditState } from "@/utils/crm/crm-edit-state";
import {Crm} from "@/models/base";



export default Vue.extend({
	data() {
		return {
			state: new CrmEditState(),
			ready: false
		};
	},
	computed: {},
	methods: {
		onCancel() {
			this.$router.push("/crm");
		},
		async onSave(crm:Crm){
			await this.$router.push(`/crm/edit/${crm.ID}`);
		}
	},
	async created() {
		let id = parseInt(this.$route.params.id);
		if (id) {
			this.state.crm = await CrmService.get(id);
		}
		this.ready = true;
	},
	components: {
		AppCrmEdit
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
